import type { ApiConfig } from './config.base';
import { config as devConfig } from './config.dev';
import { config as prodConfig } from './config.prod';
import { config as localConfig } from './config.local';

const getConfig = (): ApiConfig => {
    const mode = import.meta.env.MODE;

    // drivesource and homesource use production API
    if (mode === 'production' || mode === 'drivesource' || mode === 'homesource') {
        return prodConfig;
    }

    if (mode === 'development') {
        return devConfig;
    }

    return localConfig;
};

export const API_CONFIG: ApiConfig = getConfig();